import { render } from "./business_dashboard.html?vue&type=template&id=ba807f2a&external"
import script from "./business_dashboard.js?vue&type=script&lang=js&external"
export * from "./business_dashboard.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__